<template>
  <div class="continer">
    <HeaderTop></HeaderTop>
    <CompanyTitle></CompanyTitle>
    <RouterList></RouterList>
    <Banner></Banner>
    <!-- 面包屑 -->
    <div class="navigation">
      <span>当前位置&nbsp;:&nbsp;</span>
      <router-link to="/">&nbsp;首页&nbsp;>&nbsp;</router-link>
      <router-link to="/blogroll">通知中心</router-link>
    </div>
    <!-- 版心 -->
    <div class="content">
      <ul>
        <li @click="_getexhibition(item.id)" v-for="(item,index) in startList" :key="index">
          <div style="margin-bottom:12px">
            <h2>{{project}}</h2>
            <h3>{{item.lable}}</h3>
          </div>
          <div>
            <h4>{{projectTwo}}</h4>
            <h5 v-html="item.content"></h5>
          </div>
        </li>
      </ul>
      <div class="pagination" align="right">
        <button @click="prePage">上一页</button>
        <button @click="nextPage">下一页</button>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import { notification_query } from '../api/user/index'
import {  ERR_OK } from '../api/common/config'
import HeaderTop from '@/components/header-top/header-top.vue'
import CompanyTitle from '@/components/company-title/company-title.vue'
import RouterList from '@/components/router-list/router-list.vue'
import Banner from '@/components/banner/banner.vue'
import Footer from '@/components/footer/footer.vue'
export default {
  components: {
    HeaderTop,
    CompanyTitle,
    RouterList,
    Banner,
    Footer
  },
  data() {
    return {
      currentPage:1,
      dataList:'',
      startList:[],
      month:'',
      year:''
    }
  },
  computed:{
    project() {
        let str = ''
        this.startList.map((item,index)=>{
          str = item.updataTime.substr(0,4)
        })
          return str
      },
    projectTwo() {
        let str = ''
        this.startList.map((item,index)=>{
          str = item.updataTime.substr(5,6)
        })
          return str
      },
  },
  mounted(){
    this._notification_query()
  },
  methods:{
    _getexhibition(id) {
        this.$router.push({ path: '/blogroll-details',query:{id} })
    },
    _notification_query(){
      notification_query({number:5,page:this.currentPage}).then((res)=>{
        // console.log(res)
        if( res.data.isok === ERR_OK ) {
          this.startList = res.data.data.records
          this.dataList = res.data.data.pages
          // console.log(res.data)
        }
      })
    },
    prePage(){
      if(this.currentPage == 1) return
      this.currentPage--
      this._notification_query()
    },
    nextPage(){
      if(this.currentPage == this.dataList) return
      this.currentPage++
      this._notification_query()
    },
  }
}
</script>
<style lang="stylus" scoped>
.continer
  .navigation
    width 1200px
    height 52px
    background rgba(255,255,255,1)
    margin 30px auto 10px
    box-shadow 0px 0px 10px 0px rgba(0, 0, 0, 0.05)
    font-size 12px
    padding 18px 20px
    box-sizing border-box
    span,a 
      color #666666
    a:nth-child(3)
      color #3377FF
  .content
    width 1200px
    margin 0 auto
    height 670px
    background rgba(255,255,255,1)
    box-shadow 0px 0px 8px 0px rgba(0, 0, 0, 0.06)
    margin-bottom 180px
    .pagination
      margin 30px 20px 0 0
      button  
        background #fff
        width 68px
        height 28px
        border 1px solid #ccc
        border-radius 2px
        margin-left 20px
        font-size 12px
        &:hover 
          color #3377FF
    ul 
      padding 0 20px 
      box-sizing border-box
      height 670px
      li 
        height 134px
        border-bottom 1px solid #ccc
        padding 34px 18px 
        box-sizing border-box
        &:last-child 
          border 0
        &:hover 
          h2,h3,h4,h5 
            color #3377FF
          h5 
            opacity .4
        h2,h3,h4,h5 
          display inline-block
          color:#333333
        h2 
          width:64px;
          font-size:22px;
          font-weight:500;
          margin-right 60px
        h3 
          width:289px;
          font-size:12px;
          color:#333333
          width 900px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
        h4 
          width:56px;
          font-size:14px;
          margin-right 68px
        h5  
          color #999999
          font-size 12px
          width 900px
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
</style>
